import Lottie from 'lottie-react';
import type { LottieComponentProps } from 'lottie-react';
import { Suspense, use, useMemo } from 'react';

type LazyLottieProps = Omit<LottieComponentProps, 'animationData'> & {
  importFn: (() => Promise<{ default: object } | Record<string, unknown>>) | undefined;
};

function LottieWithData({
  promise,
  ...lottieProps
}: Omit<LottieComponentProps, 'animationData'> & {
  promise: Promise<{ default: object } | null>;
}) {
  const result = use(promise);
  if (!result) return null;
  return <Lottie animationData={(result as { default: object }).default} {...lottieProps} />;
}

export function LazyLottie({ importFn, ...lottieProps }: LazyLottieProps) {
  const promise = useMemo(() => (importFn ? importFn().catch(() => null) : null), [importFn]);

  if (!promise) return null;

  return (
    <Suspense fallback={null}>
      <LottieWithData promise={promise as Promise<{ default: object } | null>} {...lottieProps} />
    </Suspense>
  );
}
